import FormControlLabel, { FormControlLabelProps } from "@material-ui/core/FormControlLabel/FormControlLabel";
import Switch, { SwitchProps } from "@material-ui/core/Switch/Switch";
import React from "react";

export interface CustomSwitchProps extends Partial<FormControlLabelProps> {
  SwitchProps?: Partial<SwitchProps>;
}

function CustomSwitch({ SwitchProps, ...props }: CustomSwitchProps) {
  return (
    <FormControlLabel
      {...props}
      control={props.control || <Switch {...(SwitchProps || {})} color={SwitchProps?.color || "secondary"} />}
      label={props.label}
    />
  );
}

export default CustomSwitch;
